import withDateTimePicker from './withDateTimePicker'
import InputDateTime from './InputDateTime'


const InputDateTimePicker = withDateTimePicker(InputDateTime)

export default InputDateTimePicker



// WEBPACK FOOTER //
// ./src/modules/calendar/InputDateTimePicker.js